
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { RevenueType } from 'enums/RevenueType';
import { AccountingPlanModel } from './Entities.Accounting.AccountingPlan';
import { Model, ModelProperty } from 'models/Model';


export class RevenueRegistrationModel extends Model<RevenueRegistrationModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'type', type: 'RevenueType' },
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'workflowProductPlanId', type: 'number' },
		{ name: 'customerId', type: 'number' },
		{ name: 'customerType', type: 'number' },
		{ name: 'productType', type: 'number' },
		{ name: 'productId', type: 'number' },
		{ name: 'productDimension', type: 'string' },
		{ name: 'salesTypeDimension', type: 'string' },
		{ name: 'departmentDimension', type: 'string' },
		{ name: 'companyDimension', type: 'string' },
		{ name: 'createdDate', type: 'Date' },
		{ name: 'value', type: 'number' },
		{ name: 'debitGeneralJournalLineNo', type: 'number' },
		{ name: 'creditGeneralJournalLineNo', type: 'number' },
		{ name: 'period', type: 'number' },
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'isAdjustment', type: 'boolean' },
		{ name: 'accountingPlan', type: 'AccountingPlanModel', isHidden: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public type: RevenueType;
	public id?: string;
	public workflowProductPlanId?: number;
	public customerId?: number;
	public customerType?: number;
	public productType?: number;
	public productId?: number;
	public productDimension: string;
	public salesTypeDimension: string;
	public departmentDimension: string;
	public companyDimension: string;
	public createdDate?: Date;
	public value: number;
	public debitGeneralJournalLineNo?: number;
	public creditGeneralJournalLineNo?: number;
	public period?: number;
	public accountingPlanId?: string;
	public isAdjustment?: boolean;
	public accountingPlan?: AccountingPlanModel;
    
	constructor(){
		super();
		this.type = 0;
		this.id = undefined;
		this.workflowProductPlanId = undefined;
		this.customerId = undefined;
		this.customerType = undefined;
		this.productType = undefined;
		this.productId = undefined;
		this.productDimension = '';
		this.salesTypeDimension = '';
		this.departmentDimension = '';
		this.companyDimension = '';
		this.createdDate = undefined;
		this.value = 0;
		this.debitGeneralJournalLineNo = undefined;
		this.creditGeneralJournalLineNo = undefined;
		this.period = undefined;
		this.accountingPlanId = undefined;
		this.isAdjustment = undefined;
		this.accountingPlan = undefined;
		
	}
	getProperties(){
		return RevenueRegistrationModel.classProperties;
	}
}

